import request from "@/utils/request";
export default {
  // 生成支付二维码
  async redEnvelope({ id, money, qty }) {
    return request.post("/WxPay/RedEnvelope", {
      MsgId: id,
      TotalFee: money,
      Qty: qty
    });
  },
  // 支付打赏
  async postReward({ id, amount }) {
    return request.post("/Reward/Publish", {
      MsgId: id,
      Amount: amount
    });
  },
  // 打赏
  async giveReward({ msgId, amount }) {
    return request.post("/Reward/Give", {
      MsgId: msgId,
      Amount: amount
    });
  },
  // 抢红包
  async redWars(id) {
    return request.post("/WxPay/RedWars", {
      RedEnvelopeId: id
    });
  },
  // 红包详情
  async redDetail(id) {
    return request.post("/RedEnvelope/Detail", {
      RedEnvelopeId: id
    });
  },
  // 余额提现
  async withdrawal(amount) {
    return request.post("/WxPay/TransferToMyBalance", {
      Amount: amount
    });
  },
  // 购买能量豆
  async buyBeans(amount) {
    return request.post("/WxPay/BuyBeans", {
      Amount: amount
    });
  }
};
